<div class="time-picker">
    <div class="body">
        <div class="text">Select Time</div>
        <div class="time-lists" [class.disabled]="is_unscheduled">
            <div class="list border-right">
                <div class="option" [attr.id]="item === hour ? 'hour' : null" [class.selected]="item === hour" *ngFor="let item of hours_options" (tapped)="changeHour(item)">{{ item }}</div>
            </div>
            <div class="list border-right">
                <div class="option" [attr.id]="item === minute ? 'minute' : null" [class.selected]="item === minute" *ngFor="let item of minutes_options" (tapped)="changeMinute(item)">{{ item }}</div>
            </div>
            <div class="list flex-column">
                <div class="option" [class.selected]="item === meridium" *ngFor="let item of meridium_options" (tapped)="changeMeridium(item)">{{ item }}</div>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="unscheduled" *ngIf="!simple">
            <span>Or</span>
            <div class="button" [class.selected]="is_unscheduled" (tapped)="is_unscheduled = !is_unscheduled">Unscheduled</div>
        </div>
        <div class="actions">
            <div class="icon success"><i class="material-icons" (tapped)="changeTime()">done</i></div>
            <div class="icon error"><i class="material-icons" (tapped)="close()">close</i></div>
        </div>
    </div>
</div>